import { JackpotLevel, JackpotValue2 } from "./api";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { MoneyFormatter } from "./MoneyFormatter";
import { Size, LogGroup, Scale } from "./MyHelpers";
import { FontResource } from "./ResourceManager/FontResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope, ScreenProtocol } from "./ScreenProtocol";
import { Settings } from "./Settings";
import { PickBonusMessages } from "./slot/PickBonus/PickMessage";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { ZIndex } from "./ZIndex";

export class JackpotDisplayDiamondPotStep extends  IJackpotDisplay 
{

    protected view: HTMLElement = null;
	protected viewSize: Size = null;
	//Creating elements for JP
	//protected jpTitle: HTMLElement = null;
	protected titleImage: HTMLElement = null;
	protected diamondPotStepJackpotContainer: HTMLElement = null;
	protected diamondImage: HTMLElement = null;
	//protected diamondvalue: HTMLElement = null;
	//protected diamondText: HTMLElement = null;
	protected rubyStepJackpotContainer: HTMLElement = null;
	protected rubyImage: HTMLElement = null;
	//protected rubyvalue: HTMLElement = null;
	//protected rubyText: HTMLElement = null;
	protected sapphireStepJackotContainer: HTMLElement = null;
	protected emeraldImage: HTMLElement = null;
	protected emeraldText: HTMLElement = null;
	protected emmeraldStepJackotContainer: HTMLElement = null;
	protected saphireImage: HTMLElement = null;


	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	//crea el contenedor como elemento HTMLElement
	//protected jackpotContainer: HTMLElement = null;

	// protected diamondSpriteAnim: CanvasSprite = null;
	// protected diamondLocation: Point = new Point(8,-34);
	protected diamondStartTimer: IRandomInterval = null;

	// protected rubyAnim: CanvasSprite = null;
	// protected rubyLocation: Point = new Point(365,80);
	protected rubyStartTimer: IRandomInterval = null;

	// protected shappireAnim: CanvasSprite = null;
	// protected shappireLocation: Point = new Point(635,920);
	protected shappireStartTimer: IRandomInterval = null;

	// protected emeraldAnim: CanvasSprite = null;
	// protected emeraldLocation: Point = new Point(617,720);
	protected emeraldStartTimer: IRandomInterval = null;

	//LOAD JACKPOT SPRITE
	protected diamondSpriteJackpot: CanvasSprite;
	protected rubySpriteJackpot: CanvasSprite;
	protected emmeraldSpriteJackpot: CanvasSprite;
	protected sapphireSpriteJackpot: CanvasSprite;


	protected titleSpriteAnim: CanvasSprite = null;
	protected titleStartTimer: IRandomInterval = null;

	protected screenProtocol: ScreenProtocol = null;

	protected logGroup: LogGroup = new LogGroup("JackpotDisplayDiamondPotStep");

	protected systemContext: ISystemContext = null;

	protected allJpTimers: IRandomInterval[] = [];

	protected allJpSpriteAnim: CanvasSprite[] = [];

	protected TitleContainer: HTMLElement = null;

	public constructor(params: JackpotDisplayParams) {
		super(params);

		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayDiamondPotStep");

		this.resid = params.resid.Add("JackpotDisplayDiamondPotStep");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayDiamondPotStep");

		this.screenProtocol = params.screenProtocol;
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";
		this.viewSize = params.viewSize;

		// this would be "view" with jackpot frames
		this.view = document.createElement("div");
		this.view.classList.add(this.resid.ID());
		this.view.style.position = "absolute";
		this.view.style.top = Scale.Ypx(0);
		this.view.style.left = Scale.Xpx(0);
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";
		this.view.style.zIndex = "" + ZIndex.JackpotDisplay;

		//Title Container 
		this.TitleContainer = document.createElement("div");
		//this.TitleContainer.setAttribute("id", "TitleContainer");
		this.TitleContainer.classList.add(this.resid.ScopedResourceName("TitleContainer"));
		this.TitleContainer.style.display = "block";
		this.TitleContainer.style.justifyContent = "center";
		this.TitleContainer.style.alignContent = "center";
		this.TitleContainer.style.left = Scale.Xpx(0);
		this.TitleContainer.style.bottom = "0px";
		this.TitleContainer.style.position = "absolute";

		// need to get position from image
		this.TitleContainer.style.width = Scale.Wpx(1100);
		this.TitleContainer.style.height = Scale.Hpx(500);
		this.view.appendChild(this.TitleContainer);



		//Diamond  titleContainer DIV

		//Diamond Jackpot
		this.diamondPotStepJackpotContainer = document.createElement("div");
		//this.diamondPotStepJackpotContainer.setAttribute("id", "DiamondPotStepJackpotContainer");
		this.diamondPotStepJackpotContainer.classList.add(this.resid.ScopedResourceName("DiamondPotStepJackpotContainer"));
		this.diamondPotStepJackpotContainer.style.display = "flex";		
		this.diamondPotStepJackpotContainer.style.placeContent = "flex-end";
		this.diamondPotStepJackpotContainer.style.right = Scale.Xpx(-47);
		this.diamondPotStepJackpotContainer.style.top = Scale.Ypx(23);
		this.diamondPotStepJackpotContainer.style.position = "absolute";

		// need to get position from image
		//this.diamondPotStepJackpotContainer.style.width = Scale.Wpx(1805);
		//this.diamondPotStepJackpotContainer.style.height = Scale.Hpx(350);
		this.view.appendChild(this.diamondPotStepJackpotContainer);

		//Ruby Jackpot
		this.rubyStepJackpotContainer = document.createElement("div");
		//this.rubyStepJackpotContainer.setAttribute("id", "RubyStepJackpotContainer");
		this.rubyStepJackpotContainer.classList.add(this.resid.ScopedResourceName("ruby"));
		this.rubyStepJackpotContainer.style.position = "absolute";
		this.rubyStepJackpotContainer.style.display = "flex";
		this.rubyStepJackpotContainer.style.placeContent = "flex-end";
		this.rubyStepJackpotContainer.style.top = Scale.Ypx(353);
		this.rubyStepJackpotContainer.style.right = Scale.Xpx(0);
		//this.rubyStepJackpotContainer.style.width = Scale.Wpx(1200);
		//this.rubyStepJackpotContainer.style.height = Scale.Hpx(320);
		this.view.appendChild(this.rubyStepJackpotContainer);



		//Emerald Jackpot
		this.emmeraldStepJackotContainer = document.createElement("div");
		//this.emmeraldStepJackotContainer.setAttribute("id", "EmmeraldStepJackotContainer");
		this.emmeraldStepJackotContainer.classList.add(this.resid.ScopedResourceName("EmmeraldStepJackotContainer"));
		this.emmeraldStepJackotContainer.style.position = "absolute";
		this.emmeraldStepJackotContainer.style.top = Scale.Ypx(640);
		this.emmeraldStepJackotContainer.style.right = Scale.Xpx(-9);
		this.emmeraldStepJackotContainer.style.display = "flex";
		this.emmeraldStepJackotContainer.style.placeContent = "flex-end";		
		//this.emmeraldStepJackotContainer.style.width = Scale.Wpx(940);
		//this.emmeraldStepJackotContainer.style.height = Scale.Hpx(200);
		this.view.appendChild(this.emmeraldStepJackotContainer);
		//Shappire Jackpot
		

        this.sapphireStepJackotContainer = document.createElement("div");
		//this.sapphireStepJackotContainer.setAttribute("id", "SapphireStepJackotContainer");
		this.sapphireStepJackotContainer.classList.add(this.resid.ScopedResourceName("sapphire"));
		this.sapphireStepJackotContainer.style.position = "absolute";
		this.sapphireStepJackotContainer.style.top = Scale.Ypx(881);
		this.sapphireStepJackotContainer.style.right = Scale.Xpx(-9);
		this.sapphireStepJackotContainer.style.display = "flex";
		this.sapphireStepJackotContainer.style.placeContent = "flex-end";
		//this.sapphireStepJackotContainer.style.width = Scale.Wpx(750);
		//this.sapphireStepJackotContainer.style.height = Scale.Hpx(250);
		this.view.appendChild(this.sapphireStepJackotContainer);






		// recieve message from first screen
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.DiamondAnimation.msgname, (m) => this.DiamondAnimation((<PickBonusMessages.DiamondAnimation>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.JpShowFinish.msgname, (m) => this.JpShowFinish((<PickBonusMessages.JpShowFinish>m)), this.screenProtocolScope);
	}


	protected DiamondAnimation(message: PickBonusMessages.DiamondAnimation) {
		this.allJpTimers.forEach((anim: IRandomInterval) => {
			anim.Stop();
		});

		if (message.hitJp == 1) {
			this.sapphireSpriteJackpot.Start(true);
		}

		if (message.hitJp == 2) {
			this.emmeraldSpriteJackpot.Start(true);
		}

		if (message.hitJp == 3) {
			this.rubySpriteJackpot.Start(true);
		}

		if (message.hitJp == 4) {
			this.diamondSpriteJackpot.Start(true);
		}
	}

	protected JpShowFinish(message: PickBonusMessages.JpShowFinish) {
		this.allJpSpriteAnim.forEach((anim: CanvasSprite) => {
			if (anim.sprite.Running()) {
				anim.Repeat(false);
				//anim.Start(false);
				// anim.sprite.Stop();
				// anim.sprite.Update();
			}
		});

		this.StartAnimations();
	}

	// public DiamondAnimation(message:PickBonusMessages.DiamondAnimation): void
	// {
	// 	let timeline = new TimelineLite();
	// 	// message from second screen, tell us which jackpot was hitted
	// 	let jp:number = message.hitJp;



	// 	// our destination to move jackpot 
	// 	let destRect = TranslateScreen2To3(message.destRect);

	// 	// we hit jackpot 1
	// 	if(jp == 1)
	// 	{
	// 		//// Log.Debug("yorch", message.hitJp.toString());
	// 		// move the blue diamond
	// 		timeline.fromTo(this.shappireAnim.View(), 1, 
	// 			{x:0, y:0}, 
	// 			{x: destRect.x , y: destRect.y , scale: 1}
	// 		);

	// 		//rotate diamondd

	// 		timeline.to(this.shappireAnim.View(), /*rotate diamond for 2s*/ 2.5 , /* make 5 laps */ {rotation:-385 * 1 });

	// 		// reset diamond back to original values
	// 		timeline.set(this.shappireAnim.View(),{x:0, y:0, rotation:0, scale: 1});;
	// 	}

	// 	if(jp == 2)
	// 	{
	// 		// do the same for jackpot 2
	// 		// move the blue diamond
	// 		timeline.fromTo(this.emeraldAnim.View(), 1, 
	// 			{x:0, y:0}, 
	// 			{x: destRect.x , y: destRect.y , scale: 1}
	// 		);
	// 		//rotate diamond}
	// 		timeline.to(this.emeraldAnim.View(), /*rotate diamond for 2s*/ 2.5 , /* make 5 laps */ {rotation:-385 * 2 });
	// 		// reset diamond back to original values
	// 		timeline.set(this.emeraldAnim.View(),{x:0, y:0, rotation:0, scale: 1});;

	// 	}

	// 	if(jp == 3)
	// 	{
	// 		// do the same for jackpot 2
	// 		// move the blue diamond
	// 		timeline.fromTo(this.rubyAnim.View(), 1, 
	// 			{x:0, y:0}, 
	// 			{x: destRect.x , y: destRect.y , scale: 1}
	// 		);

	// 		//rotate diamond}

	// 		timeline.to(this.rubyAnim.View(), /*rotate diamond for 2s*/ 4.5 , /* make 5 laps */ {rotation:-365 * 3 });

	// 		// reset diamond back to original values
	// 		timeline.set(this.rubyAnim.View(),{x:0, y:0, rotation:0, scale: 1});;

	// 	}
	// 	if(jp == 4)
	// 	{
	// 		// do the same for jackpot 2
	// 		// move the blue diamond
	// 		timeline.fromTo(this.diamondSpriteAnim.View(), 1, 
	// 			{x:0, y:0}, 
	// 			{x: destRect.x , y: destRect.y , scale: 1},
	// 		);

	// 		//rotate diamond}

	// 		timeline.to(this.diamondSpriteAnim.View(), /*rotate diamond for 2s*/ 0.03, /* make 5 laps */ {rotation:5 * 1 });
	// 		timeline.to(this.diamondSpriteAnim.View(), /*rotate diamond for 2s*/ 0.03, /* make 5 laps */ {rotation:-5 * 1 });
	// 		timeline.to(this.diamondSpriteAnim.View(), /*rotate diamond for 2s*/ 0.03, /* make 5 laps */ {rotation:-5 * 1 });
	// 		timeline.to(this.diamondSpriteAnim.View(), /*rotate diamond for 2s*/ 0.03, /* make 5 laps */ {rotation:5 * 1 });
	// 		timeline.to(this.diamondSpriteAnim.View(), /*rotate diamond for 2s*/ 19.5 , /* make 5 laps */ {rotation:-365 * 5 });


	// 		// reset diamond back to original values
	// 		timeline.set(this.diamondSpriteAnim.View(),{x:0, y:0, rotation:0, scale: 1});;

	// 	}
	// }

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		// jackpot frames image
		//resourceManager//.Add(new ImageResource(this.jackpot + "background.3.1.png", this.resid.ScopedResourceName("jackpotframes")));
		//resourceManager.Add(new ImageResource(this.jackpot + "diamond_pot_title.png", this.resid.ScopedResourceName("jackpotTitle")));
		//resourceManager.Add(new ImageResource(this.jackpot + "diamond_frame.png", this.resid.ScopedResourceName("jpDiamondMa")));

		//load Sprite Jackpot 

		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStep/Sprites/DiamondStep", this.resid.Add("DiamondStep"), true, this.logGroup.Add("DiamondStep"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStep/Sprites/RubyStep", this.resid.Add("RubyStep"), true, this.logGroup.Add("RubyStep"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStep/Sprites/EmmeraldStep", this.resid.Add("EmmeraldStep"), true, this.logGroup.Add("EmmeraldStep"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStep/Sprites/SapphireStep", this.resid.Add("SapphireStep"), true, this.logGroup.Add("SapphireStep"), true));

		this.TitlePrepare(resourceManager);
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));

	}

	public TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStep/Sprites/DiamondPotTitleStep", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public TitleLoaded(resourceManager: IReadOnlyResourceManager) {
		this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.W(1200), Scale.H(600))});
		this.titleSpriteAnim.View().style.position = "absolute";
		this.titleSpriteAnim.View().style.bottom=Scale.Ypx(0);
		this.titleSpriteAnim.View().style.left= Scale.Xpx(-65);
		//this.titleSpriteAnim.Scale(1.1);
		this.TitleContainer.appendChild(this.titleSpriteAnim.View());
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		this.TitleLoaded(resourceManager);
		await this.createJPLevelText(resourceManager);
		this.createSpritesJpLevel(resourceManager);
		this.StartAnimations();
		this.Update();		
	}

	protected createSpritesJpLevel(resourceManager : IReadOnlyResourceManager){
		//this.DragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("diamond_frame")).CssBackground();


		this.diamondSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("DiamondStep")).sprite, canvasSize: new Size(Scale.W(1805), Scale.H(375))});
		//this.diamondSpriteJackpot.Start();
		this.diamondPotStepJackpotContainer.appendChild(this.diamondSpriteJackpot.View());
        this.diamondSpriteJackpot.ScaleNonUniform(1.1,1);


		//this.GrandDragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("ruby_frame")).CssBackground();
		this.rubySpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("RubyStep")).sprite, canvasSize: new Size(Scale.W(1200), Scale.H(320))});
		//this.rubySpriteJackpot.Start();
		this.rubySpriteJackpot.ScaleNonUniform(1, 1.15);
		this.rubyStepJackpotContainer.appendChild(this.rubySpriteJackpot.View());


		//this.MiniDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("emerald_frame")).CssBackground();
		this.emmeraldSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("EmmeraldStep")).sprite, canvasSize: new Size(Scale.W(950), Scale.H(250))});
		//this.emmeraldSpriteJackpot.Start();
		this.emmeraldSpriteJackpot.ScaleNonUniform(1.20, 1);
		this.emmeraldStepJackotContainer.appendChild(this.emmeraldSpriteJackpot.View());



		//this.MinorDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("sapphire_frame")).CssBackground();
		this.sapphireSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("SapphireStep")).sprite, canvasSize: new Size(Scale.W(766), Scale.H(200))});
		//this.sapphireSpriteJackpot.Start();
		this.sapphireStepJackotContainer.appendChild(this.sapphireSpriteJackpot.View());

		this.allJpSpriteAnim.push(this.diamondSpriteJackpot);
		this.allJpSpriteAnim.push(this.rubySpriteJackpot);
		this.allJpSpriteAnim.push(this.emmeraldSpriteJackpot);
		this.allJpSpriteAnim.push(this.sapphireSpriteJackpot);

		// repeat at random intervals winthin 5 to 10 seconds
		this.diamondStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 10000, 30000, () => this.diamondSpriteJackpot.Start(false));
		this.rubyStartTimer = this.systemContext.TimingContext().CreateRandomInterval("rubyStartTimer", 10000, 30000, () => this.rubySpriteJackpot.Start(false));
		this.shappireStartTimer = this.systemContext.TimingContext().CreateRandomInterval("shappireStartTimer", 10000, 30000, () => this.sapphireSpriteJackpot.Start(false));
		this.emeraldStartTimer = this.systemContext.TimingContext().CreateRandomInterval("emeraldStartTimer", 10000, 30000, () => this.emmeraldSpriteJackpot.Start(false));
		this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 10000, 30000, () => this.titleSpriteAnim.Start(false));

		this.allJpTimers.push(this.diamondStartTimer);
		this.allJpTimers.push(this.rubyStartTimer);
		this.allJpTimers.push(this.shappireStartTimer);
		this.allJpTimers.push(this.emeraldStartTimer);
	}

	protected async createJPLevelText( resourceManager : IReadOnlyResourceManager){

		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		let jp4TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("White"),
			width: Scale.W(1300),
			height: Scale.H(204),//195
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(451);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(105); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.diamondPotStepJackpotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());

		let jp3TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(922),
			height: Scale.H(138),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		//JackpotFont 3
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(239);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(112);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.rubyStepJackpotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		let jp2TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(592),
			height: Scale.H(110),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		//JackpotFont 2
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(289);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(84);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.emmeraldStepJackotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());

		let jp1TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(493),
			height: Scale.H(95),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		//JackpotFont 1
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(210);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(65);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";		
		this.sapphireStepJackotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();
	}

	// deleted too much, this is how this particular game gets displayed to screen,
	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void {
		// animation needs to be updated for frames to go forward
		// this.diamondSpriteAnim.Update();
		// this.rubyAnim.Update();
		// this.shappireAnim.Update();
		// this.emeraldAnim.Update();
		this.titleSpriteAnim.Update();
		this.jackpotTextMapping[JackpotLevel.Jp4].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3].Draw();
		//Change STYLE JP1 and JP2
		this.jackpotTextMapping[JackpotLevel.Jp1].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2].Draw();
		//UPDATE JACKPOT ANIM
		this.diamondSpriteJackpot.Update();
		this.rubySpriteJackpot.Update();
		this.emmeraldSpriteJackpot.Update();
		this.sapphireSpriteJackpot.Update();
	}

	public StopAnimations(): void {
		// stop animations and their timer to startup in near future

		// if (this.diamondSpriteAnim != null) this.diamondSpriteAnim.Stop();
		// this.diamondStartTimer.Stop();

		// if (this.rubyAnim != null) this.rubyAnim.Stop();
		// this.rubyStartTimer.Stop();

		// if (this.shappireAnim != null) this.shappireAnim.Stop();
		// this.shappireStartTimer.Stop();

		// if (this.emeraldAnim != null) this.emeraldAnim.Stop();
		// this.emeraldStartTimer.Stop();

		if (this.titleSpriteAnim != null) this.titleSpriteAnim.Stop();
		this.titleStartTimer.Stop();
	}

	public StartAnimations(): void {

		//start within 5 seconds
		if (this.diamondSpriteJackpot != null) {
			this.diamondStartTimer.Start();
		}

		if (this.rubySpriteJackpot != null) {
			this.rubyStartTimer.Start();
		}

		if (this.sapphireSpriteJackpot != null) {
			this.shappireStartTimer.Start()
		}

		if (this.emmeraldSpriteJackpot != null) {
			this.emeraldStartTimer.Start()
		}

		if (this.titleSpriteAnim != null) {
			this.titleStartTimer.Start()
		}
	}

	//protected jpValues: JackpotValue2[] = [];
	// public  UpdateValues(jackpotValues: JackpotValue2[]): void {
	// 	this.jpValues = jackpotValues;
	// 	if (this.pauseJackpotValues) {
	// 		console.log("IsJackpot");
	// 		return
	// 	}
	// 	let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);
	// 	if (jp1 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp1].SetTarget(jp1.CurrentMultipliedValue);
	// 	}

	// 	let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2);
	// 	if (jp2 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp2].SetTarget(jp2.CurrentMultipliedValue);
	// 	}

	// 	let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
	// 	if (jp3 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp3].SetTarget(jp3.CurrentMultipliedValue);
	// 	}

	// 	let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
	// 	if (jp4 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp4].SetTarget(jp4.CurrentMultipliedValue);
	// 	}
	// }

	public TitleHide() {
		this.titleSpriteAnim.Hide();
		this.titleSpriteAnim.Stop();
	}
	public TitleShow() {
		this.titleSpriteAnim.Show();
		this.titleStartTimer.Start()
	}
	// public Reset() {
	// 	console.log("Reset JackpotValues:");
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "ResetValue:", jp.ResetValue);
	// 	});
	// }

	// public Resume() {
	// 	console.log("Resume JackpotValues:");
	// 	this.pauseJackpotValues = false;
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "CurrentValue:", jp.CurrentValue);
	// 	});
	// 	this.UpdateValues(this.jpValues);
	// }

	// protected pauseJackpotValues = false;
	// public Pause() {
	// 	console.log("Pause JackpotValues");
	// 	this.pauseJackpotValues = true;
	// }
}